import { OutsideInventorySeed } from '../../../store/OutsideInventory';
import type { LocationGridRow } from './locationsGridColumnDefs';

const ADDRESS_GROUP_KEY = 'addr-';

/** The manual form's seed for a location: its address, labels and, for a Location Account, its id. */
export const outsideInventoryFromLocation = (location: LocationGridRow): OutsideInventorySeed => ({
  address: location.address,
  customerLocationName: location.customer_location_name ?? '',
  ...(location.location_key.startsWith(ADDRESS_GROUP_KEY) ? {} : { locationId: location.location_key }),
  addressInfo: {
    address: location.street_address ?? '',
    streetAddress: location.street_address ?? '',
    locationName: location.address,
    city: location.city ?? '',
    state: location.state ?? '',
    zip: location.zip ?? '',
    country: location.country ?? '',
    latitude: location.latitude ?? 0,
    longitude: location.longitude ?? 0,
    number: location.location_code ?? ''
  }
});
